// extracted by mini-css-extract-plugin
export default {"spec-subtitle":"product-specifications__spec-subtitle___3QQOW","header-tabs":"product-specifications__header-tabs___1xIqj"};